<div class="modal fade" [class.show]="showModal" [style.display]="showModal ? 'block' : 'none'" tabindex="-1" role="dialog">
  <div class="modal-dialog" role="document">
    <div class="card">
      <div class="card-header">
          <h4 class="card-title">{{ title }}</h4>
          <p class="category">{{ subTitle }}</p>
      </div>
      <form [formGroup]="form" class="form-horizontal" action="" method="post" novalidate="">        
        <fieldset *ngFor="let column of columns; let i = index">
                <div class="form-group">
                    <label class="col-sm-4 control-label" [attr.for]="'input-' + i" [innerHTML]="column.label">                      
                    </label>
                    <div class="col-sm-7">   
                      <app-form-field                      
                      [column]="column"
                      [controlName]="column.name"                      
                      [inputId]="'input-' + i"
                      ></app-form-field>
                      <div *ngIf="form.controls[column.name].invalid && (form.controls[column.name].dirty || form.controls[column.name].touched)">
                        <div *ngFor="let errorKey of getObjectKeys(column.errorMessages || {})">
                          <span *ngIf="form.controls[column.name].hasError(errorKey)" class="text-danger">
                            {{ column.errorMessages?.[errorKey] }}
                          </span>
                        </div>
                      </div>                                             
                    </div>                    
                </div>
            </fieldset>           
      </form>
      <div class="modal-footer">
        <button 
          type="button" 
          class="btn btn-secondary" 
          (click)="closeModal()"
        >
          Close
        </button>
        <button          
          type="button"
          class="btn btn-primary"
          (click)="openConfirmDialog()"
          [disabled]="form.invalid"
        >
          Save Changes
        </button>        
      </div>
    </div>    
  </div>
</div>
<app-confirm-dialog
  *ngIf="showConfirmDialog"
  [title]="'Confirm Action'"
  message="Are you sure you want to save changes?"
  (confirm)="handleConfirm()"
  (cancel)="handleCancel()"
></app-confirm-dialog>